"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireWildcard(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function (e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != typeof e && "function" != typeof e) return { default: e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n.default = e, t && t.set(e, n), n; }
const InputValidationMessage = _ref => {
  let {
    value,
    errorMessage,
    successMessage
  } = _ref;
  return /*#__PURE__*/_react.default.createElement(_react.Fragment, null, value && value.length > 0 && (!errorMessage || successMessage) && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-right"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "check")), successMessage && /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-success"
  }, successMessage)), errorMessage && /*#__PURE__*/_react.default.createElement(_react.Fragment, null, /*#__PURE__*/_react.default.createElement("span", {
    className: "icon is-small is-right"
  }, /*#__PURE__*/_react.default.createElement("i", {
    className: "material-icons"
  }, "warning")), /*#__PURE__*/_react.default.createElement("p", {
    className: "help is-danger"
  }, errorMessage)));
};
InputValidationMessage.propTypes = {
  value: _propTypes.default.string,
  errorMessage: _propTypes.default.string,
  successMessage: _propTypes.default.string
};
InputValidationMessage.defaultProps = {
  value: null,
  errorMessage: null,
  successMessage: null
};
var _default = exports.default = InputValidationMessage;
//# sourceMappingURL=InputValidationMessage.js.map